import React, { forwardRef } from 'react';
import { mappingPropertyType } from '../constants';
import BaseInput from 'src/shared/components/inputs/BaseInput';

const FixedValueInput = forwardRef(({
  type, name, value, setFieldValue, defaultValue, readOnly,
}, ref) => (
  <BaseInput
    type={(type === mappingPropertyType.integer || type === mappingPropertyType.decimal ? 'number' : 'text')}
    label=''
    name={name}
    value={value}
    onChange={({ value }) => setFieldValue(value)}
    onBlur={() => { }}
    defaultValue={defaultValue}
    readOnly={readOnly}
    ref={ref}
  />
));

export default FixedValueInput;
